import React from "react";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  "@keyframes versionSkeletonShimmer": {
    "0%":   { backgroundPosition: "-200px 0" },
    "100%": { backgroundPosition: "calc(200px + 100%) 0" },
  },
  skeleton: {
    display: "inline-block",
    height: "1em",
    width: 160,
    borderRadius: 4,
    background:
      "linear-gradient(90deg, #eee 0%, #f5f5f5 50%, #eee 100%)",
    backgroundSize: "200px 100%",
    backgroundRepeat: "no-repeat",
    animation: "$versionSkeletonShimmer 1.2s ease-in-out infinite",
  },
});

const VersionSkeleton = () => {
  const classes = useStyles();
  return <span className={classes.skeleton} aria-label="Loading version" />;
};

export default VersionSkeleton;
